import VueSocketIO from 'vue-socket.io';
import Vue from 'vue';

Vue.use(
    new VueSocketIO({
        debug: true,
        connection: process.env.VUE_APP_API_HOST
    })
);
